// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2clbJ","select":"styles_select__1IIRr"};